import type {ReactAction} from '@netx/core/bootstrap';
import {faArrowsAlt} from '@fortawesome/pro-solid-svg-icons';
import {canCategorizeMoveCurrentCartAssets} from '../enablers';
import {CART_CURRENT_ACTION_LABELS} from '../locales';
import {CART_CURRENT_EVENT} from './constants';

/**
 * Move cart assets to folder
 * @param params
 * @returns Action
 */
export const cartActionCategorizeMove = (
	params: Partial<ReactAction> = {},
): ReactAction => ({
	name: 'cart-current-categorize-move',
	cb: () => dispatcher.trigger(CART_CURRENT_EVENT.CATEGORIZE_MOVE),
	enableTest: () => canCategorizeMoveCurrentCartAssets(),
	icon: faArrowsAlt,
	get label() {
		return CART_CURRENT_ACTION_LABELS.CATEGORIZE_MOVE;
	},
	...params,
});

export default cartActionCategorizeMove;
